<template>
  <div class="application__top top-bar flex">
    <div class="flex center ml-10">
      <span class="sprite-logo" @click="logoHandler()"/>
    </div>
    <div class="zoom flex full center">
      <sw-button
        class="button-top button-top-icon center mr-5"
        @click="onZoomOut"
        :selectable="false"
      >
        <span class="sprite-moins sprite-alpha"></span>
      </sw-button>
      <span class="zoom-label">{{zoomFactor}}%</span>
      <sw-button
        class="button-top button-top-icon center ml-5"
        @click="onZoomIn"
        :selectable="false"
      >
        <span class="sprite-plus sprite-alpha"></span>
      </sw-button>
    </div>
    <div class="flex mr-14">
      <sw-button
        class="button-top center undo-top mr-14"
        label="Retour en arrière"
        :selectable="false"
        @click="onUndo"
      />
      <sw-drop-down>
        <sw-button
          slot="activator"
          font="fa"
          icon="keyboard-o"
          class="button-keyboard button button-top button-top-icon center mr-15"
        ></sw-button>
        <div class="shortcut-container">
        <ul>
          <li><span class="shortcut-description">Afficher / Masquer la grille</span> <span class="shortcut">G</span></li>
          <li><span class="shortcut-description">Activer / Désactiver le magnétisme</span> <span class="shortcut">M</span></li>
          <li><span class="shortcut-description">Ouvrir le panneau des ajustements </span><span class="shortcut">A</span></li>
          <li><span class="shortcut-description">Ouvrir le panneau des filtres </span><span class="shortcut">F</span></li>
          <li><span class="shortcut-description">Ouvrir le panneau des formes </span><span class="shortcut">O</span></li>
          <li><span class="shortcut-description">Ouvrir le panneau des templates </span><span class="shortcut">L</span></li>
          <li><span class="shortcut-description">Ouvrir le panneau des calques</span> <span class="shortcut">C</span></li>
          <li><span class="shortcut-description">Ouvrir la fenêtre des images </span><span class="shortcut">I</span></li>
          <li><span class="shortcut-description">Créer un champ de texte </span><span class="shortcut">T</span></li>

        </ul>
        </div>
      </sw-drop-down>
    
      <sw-button class="button-top button-top-icon center mr-5" :toggle="true" @click="onShowGrid">
        <span class="sprite-grille sprite-alpha"></span>
      </sw-button>
      <sw-button
        class="button-top button-top-icon center"
        :toggle="true"
        @click="onToggleMagnet"
        :selected="true"
        ref="magnetButton"
      >
        <span class="sprite-magnet sprite-alpha"></span>
      </sw-button>
    </div>

    <sw-button
      slot="activator"
      class="flex button dropdown-button-export-modal center vertical"
      v-if="saveMenuList.length === 0"
      @click="exportImage('png')"
    >Enregistrer</sw-button>
    <sw-drop-down direction="top right" v-else>
      <sw-button
        slot="activator"
        class="flex button dropdown-button-export-modal center vertical"
      >Enregistrer</sw-button>
      <sw-button v-for="menuItem in saveMenuList" :key="menuItem.label" font="fa" :icon='menuItem.icon+" mr-5"' class="center-y button-drop-down" @click="action(menuItem)">
        {{menuItem.label}}
      </sw-button>
    </sw-drop-down>
    <sw-button v-if="closeButton" icon='close' font='fa' class="flex button-top-close  mx-10 center vertical" @click="$emit('closePixel')"/>
    <a ref="imgdownload"/>
  </div>
</template>
<script>
import PictureSaveModal from '@/components/modal/PictureSaveModal.vue';
import { clickLogo, clickMenu, sendImage } from '@/model/PixelIOGateway';
import { mapGetters } from 'vuex';
export default {
  name: 'topbar',
  components: {
    PictureSaveModal
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.editor.on('zoomUpadted', zoomValue => {
      this.zoomFactor = Math.round(zoomValue * 100)
    })
    this.editor.on('EVENT_ACTIVE_MAGNET', evt=> this.$refs.magnetButton.click())
    this.editor.on('EVENT_SHOW_GRID', evt=> this.$refs.magnetButton.click())
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      zoomFactor: 50,
      openSaveModal: false,
      b64: '',
      currentDownload: null
    }
  },
  props: {
    editor: Object
  },
  computed: {
    ...mapGetters(['canSaveLocal', 'openedMode', 'getDomain', 'closeButton','saveMenuList']),
  },
  methods: {
    onZoomIn() {
      this.editor.zoom(0.1)
      this.zoomFactor = Math.round(this.editor.getZoom() * 100)
    },
    onZoomOut() {
      this.editor.zoom(-0.1)
      this.zoomFactor = Math.round(this.editor.getZoom() * 100)
    },
    onToggleMagnet() {
      this.editor.toggleMagnet()
    },
    onShowGrid() {
      this.editor.showGrid()
    },
    onUndo() {
      this.editor.undo()
    },
    saveImage(format) {
      this.$refs.imgdownload.href = this.editor.savePicture(format, 1)
      this.$refs.imgdownload.download = `mypicture.${format === 'jpeg' ? 'jpg' : format}`
      this.$refs.imgdownload.click()
    },
    exportImage(format) {
      let base64 = this.editor.savePicture(format, 1)
      sendImage(base64, this.getDomain)
    },

    action(item){
      if(item.directDownload){
        this.saveImage(item.data.format)
      }else{
        let base64 = this.editor.savePicture(item.data.format, 1)
        clickMenu(this.getDomain, {image:base64,  ...item.data, eventName:item.eventName})
      }
    },

    logoHandler() {
      clickLogo(this.getDomain)
    }

  },
  watch: {}
}
</script>
<style lang="stylus">
.button-keyboard 
  font-size: 1.4rem
.shortcut-container
  background: var(--secondary-background)
  display:flex
  width: max-content
  padding:10px 20px 20px 20px
  font-weight: 300
  font-size: 14 px
  ul
    margin: 0px;
    padding-left: 0px;
    li
      margin-top: 15px
      display: flex

.shortcut-description
  flex: 1
  margin-right: 15px
.shortcut
  text-align: center;
  color:var(--action-color)
  width:14px
  font-weight: 900
</style>





// WEBPACK FOOTER //
// src/components/top/TopBar.vue